import type React from 'react';
import { useEffect } from 'react';
import useInput from '@hooks/useInput';
import Button from '@components/Button';
import Modal from '@components/Modal';
import Title from '@components/Title';
import Input from '@components/Input';
import Checkbox from '@components/Checkbox';
import useToggle from '@hooks/useToggle';

interface Props {
  oldName?: string;
  isOpen?: boolean;
  onRequestClose: () => void;
  onConfirm: (result: {
    name: string;
    renameHotspot: boolean;
    renameSandTable: boolean;
  }) => void;
}

function RenameSceneModal({
  oldName,
  isOpen = false,
  onRequestClose,
  onConfirm,
}: Props) {
  const input = useInput<HTMLInputElement>(oldName);
  const disabled = !input.value;
  const hsChecked = useToggle(true);
  const stChecked = useToggle(true);
  useEffect(() => {
    input.select();
  }, []);
  const handleConfirm = () => {
    input.select();
    onConfirm({
      name: input.value.trim(),
      renameHotspot: hsChecked.isOn,
      renameSandTable: stChecked.isOn,
    });
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      header={<Title>场景重命名</Title>}
      footer={
        <Button disabled={disabled} onClick={handleConfirm}>
          确认操作
        </Button>
      }
    >
      <div className="flex h-full flex-col justify-center">
        <Input
          className="h-40 w-full"
          maxLength={50}
          placeholder="请输入场景名称"
          onClear={() => {
            input.clear();
            input.focus();
          }}
          onKeyDown={handleKeyDown}
          {...input.bind}
        />
        <Checkbox
          className="mt-20 flex items-center"
          checked={hsChecked.isOn}
          onToggle={hsChecked.set}
          label="同时修改“场景切换”热点标题"
        />
        <Checkbox
          className="mt-10 flex items-center"
          checked={stChecked.isOn}
          onToggle={stChecked.set}
          label="同时修改沙盘中“场景标记”的标记标题"
        />
      </div>
    </Modal>
  );
}

export default RenameSceneModal;
